import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Returns whether the current user has an active Premium subscription.
 * Checks Stripe first, falls back to the local user_subscriptions table.
 */
export const useIsPremium = () => {
  const { user } = useAuth();
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!user) {
      setIsPremium(false);
      setLoading(false);
      return;
    }

    const check = async () => {
      try {
        const { data } = await supabase.functions.invoke("check-subscription");
        if (cancelled) return;
        if (data?.subscribed) {
          setIsPremium(true);
          setLoading(false);
          return;
        }
        const { data: dbSub } = await supabase
          .from("user_subscriptions" as any)
          .select("plan, premium_status")
          .eq("user_id", user.id)
          .maybeSingle();
        if (cancelled) return;
        const dbActive =
          dbSub &&
          ((dbSub as any).plan === "premium" || (dbSub as any).plan === "teacher_premium") &&
          (dbSub as any).premium_status === "active";
        setIsPremium(!!dbActive);
      } catch {
        if (!cancelled) setIsPremium(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    check();
    const interval = setInterval(check, 60000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user]);

  return { isPremium, loading };
};